/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HelperResponseDto } from '../../models/helper-response-dto';

export interface PosSessionsControllerGetHelpers$Params {

/**
 * POS Session ID
 */
  id: string;
}

export function posSessionsControllerGetHelpers(http: HttpClient, rootUrl: string, params: PosSessionsControllerGetHelpers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HelperResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerGetHelpers.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HelperResponseDto>>;
    })
  );
}

posSessionsControllerGetHelpers.PATH = '/pos/sessions/{id}/helpers';
